const initialState = {
    userDetails: {},
    flights: {
        departureFlights:[],
        departureAirport:''
    },
    homeSearch:{
        departure:'',
        destination:'',
        adultsNumber:1,
        startDate:'',
        endDate:''
    },
    notification: null
  };
  
  export default initialState;
  